import type { ComponentProps } from 'react';
import React from 'react';

import { TextField } from '../../TextField';

// ─────────────────────────────────────────────────────────────────────────────

export const TextFieldZipCode = (props: Props) => (
  <TextField
    onChangeTextGuard={validateChangedText}
    autoCapitalize="characters"
    autoCorrect={false}
    textContentType="postalCode"
    keyboardType="number-pad"
    maxLength={8}
    {...props}
  />
);

// ─── Helpers ─────────────────────────────────────────────────────────────────

function validateChangedText(zipCode: string) {
  return ONLY_NUMBERS.test(zipCode);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ONLY_NUMBERS = /^\d*$/;

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof TextField>;
